import type { RefreshFailure, RefreshJob } from "./types";

const STORES: Record<string, string> = { steam_kz: "Steam KZ", steambuy: "SteamBuy", gabestore: "GabeStore", payberry: "Payberry", igrovoy: "Игровой", ggsel: "ggsel", plati: "Plati.Market", ps_tr: "PS Store TR", ps_in: "PS Store IN" };
export const storeLabel = (store: string) => STORES[store] ?? store;
export const REASONS = {
  not_found: ["Товар не найден", "Откройте ссылку магазина. Если товар удалён, замените источник в карточке."],
  rate_limit: ["Слишком много запросов", "Подождите несколько минут и повторите проверку."],
  access: ["Магазин ограничил доступ", "Проверьте доступность страницы магазина и повторите позже."],
  timeout: ["Не дождались ответа", "Повторите проверку: магазин мог быть временно недоступен."],
  partial: ["Неполный поиск", "Часть предложений не ответила. Повторите позже; последняя известная цена сохранена."],
  parse: ["Товар или издание не распознаны", "Проверьте товар и выбранное издание по ссылке. При необходимости замените источник."],
  network: ["Нет соединения", "Проверьте доступность магазина и повторите позже."],
  other: ["Ошибка проверки", "Повторите проверку. Если ошибка остаётся, скопируйте отчёт для разбора."],
} as const;
export type ReasonKind = keyof typeof REASONS;
export function reasonKind(reason: string): ReasonKind {
  if (/HTTP (404|410)/i.test(reason)) return "not_found";
  if (/HTTP 429/i.test(reason)) return "rate_limit";
  if (/HTTP (401|403)/i.test(reason)) return "access";
  if (/врем[яе]|за отведённое|timeout/i.test(reason)) return "timeout";
  if (/неполн|часть кандидатов/i.test(reason)) return "partial";
  if (/разобрать|издание|структур/i.test(reason)) return "parse";
  if (/соединиться|соединени/i.test(reason)) return "network";
  return "other";
}
export function failureDetails(failure: RefreshFailure): NonNullable<RefreshFailure["details"]> {
  return failure.details?.length ? failure.details : (failure.stores.length ? failure.stores : [""]).map(store => ({ store, reason: failure.reason }));
}
export function reportText(job: RefreshJob): string {
  return [`PT Wishlist — проверка №${job.id}`, `Проверено ${job.completed}/${job.total}; игр с ошибками: ${job.failed_games}.`,
    ...job.failures.flatMap(item => [item.title, ...failureDetails(item).map(detail => `  ${storeLabel(detail.store) || "Проверка игры"}: ${detail.reason}`)]),
    ...(job.resolved_failures ?? []).map(item => `${item.title}: повторная проверка без ошибок.`),
  ].join("\n");
}
